<template src="./vehicleinspectionform.html"></template>
<script>
  import Axios from "axios";
  import $ from "jquery";
  import GetcurrencySymbol from "@/assets/js/currency_sign.js";

  import VehicleInspectionViewDetails from "@/pages/vehicleinspections/vehicleinspectionview/vehicleinspectionviewdetails";
  var moment = require("moment");
  export default {
    components: {
      VehicleInspectionViewDetails,
    },
    filters: {
      date: function (data) {
        var sendDate = "N/A";
        if (data != "" && data != null) {
          sendDate = moment(data).format("DD-MM-YYYY");
        }
        return sendDate;
      },
    },
    props: ["UniqueId", "FormType", "InspectionId"],
    data() {
      return {
        currency_type : GetcurrencySymbol(),
        Saving: false,
        VehicleInspections: [],
        FleetInspectionsList: [],
        ImageEndpoint: Endpoints.Helper.Image + "/",
        MarkingCode: [],
        CompanyLogo: "",
        NewInspection: {
          vehicle_id: 0,
          mechanic_name: "",
          inspection_submit_id: [],
          marking_code: [],
          mm: [],
          psi: [],
          age: [],
          notes: "",
          rectifications: "",
          current_mileage: "",
          vehicle: {
            sb_force: "",
            sb_eff: "",
            pb_force: "",
            pb_eff: "",
            eb_force: "",
            eb_eff: "",
            total_weight: "",
          },
          roadBrake: {
            brake_performance: "",
            decelerometer_test_kph: "",
            decelerometer_test_mph: "",
            roller_brake_test: "",
            road_speed_limiter: "",
            service_im_71: "",
            service_im_72: "",
            parking_im_73: "",
            load_condition: "",
            overall_comments: "",
          },
          brakeTemperature: {
            os_axle_1: "",
            os_axle_2: "",
            os_axle_3: "",
            os_axle_4: "",
            ns_axle_1: "",
            ns_axle_2: "",
            ns_axle_3: "",
            ns_axle_4: "",
            assessment_date: "",
            data_download: "",
          },
          brakes: [],
        },
        brakesList: [1],
        firstBrake: 1,
        inspectionsVal: [],
        isDraft: 1,
        RectificationsData: [],
        VehicleData: [],
        VehicleType: "Vehicle",
      };
    },
    validations: {
      NewInspection: {},
    },
    mounted() {
      document.title = pbx_SiteTitle + " - Vehicles Inspection View";

      setTimeout(() => {
        this.GetVehicleInspectionsList();
      }, 500);
      this.NewInspection.brakes.push({
        brake_no: "",
        left: "",
        right: "",
        l_oval: "",
        r_oval: "",
        imba: "",
        max_imba: "",
        pedal_f: "",
        left_p: "",
        right_p: "",
        weight: "",
        eff: "",
        lmi: "",
        rmi: "",
        lrr: "",
        rrr: "",
      });

      setInterval(() => {
        this.saveInspectionWithInterval();
      }, 60000);
    },

    methods: {
      addMore() {
        this.firstBrake = this.firstBrake + 1;
        this.brakesList.push(this.firstBrake);
        this.NewInspection.brakes.push({
          brake_no: "",
          left: "",
          right: "",
          l_oval: "",
          r_oval: "",
          imba: "",
          max_imba: "",
          pedal_f: "",
          left_p: "",
          right_p: "",
          weight: "",
          eff: "",
          lmi: "",
          rmi: "",
          lrr: "",
          rrr: "",
        });
      },
      saveInspectionWithInterval() {
        this.NewInspection.save_type = "draft";
        this.NewInspection.unique_id = this.UniqueId;
        this.NewInspection.rectifications = this.RectificationsData;
        this.NewInspection.unique_url =
          window.location.origin + "/create-vehicle-inspection/";
        Axios.post(Endpoints.VehicleInspections.Create, {
          ...this.NewInspection,
        }).then((Response) => {});
      },
      removeBrake(key) {
        this.brakesList.splice(key, 1);
        this.NewInspection.brakes.splice(key, 1);
      },
      GetVehicleInspectionsList(type = "") {
        var obj = {};
        obj.unique_id = this.UniqueId;
        this.ShowLoader = true;
        Axios.post(
          Endpoints.VehicleInspections.SubmitInspectionDetails,
          obj
        ).then((Response) => {
          this.ShowLoader = false;
          if (Response.data.success) {
            this.VehicleInspections = Response.data.FleetInspectionSubmitData;
            this.FleetInspectionsList = Response.data.FleetInspections;
            this.MarkingCodes = Response.data.markingCodes;

            if (
              typeof Response.data.VehicleData != "undefined" &&
              Response.data.VehicleData.id > 0
            ) {
              this.VehicleData = Response.data.VehicleData;
              this.NewInspection.vehicle_id = Response.data.VehicleData.id;

              if (this.VehicleData.class == "Trailer") {
                this.VehicleType = "Trailer";
              }
              if (this.VehicleData.class == "Crane") {
                this.VehicleType = "Crane";
              }
            }

            if (this.VehicleInspections != null) {
              if (this.FormType != "Edit") {
                this.isDraft = this.VehicleInspections.is_draft == 1 ? 1 : 0;
              }

              this.NewInspection.mechanic_name =
                this.VehicleInspections.mechanic_name;

              if (
                typeof this.VehicleInspections.tyres != "undefined" &&
                this.VehicleInspections.tyres != ""
              ) {
                this.tyresData = JSON.parse(this.VehicleInspections.tyres);
                this.NewInspection.mm = this.tyresData.mm;
                this.NewInspection.psi = this.tyresData.psi;
                this.NewInspection.age = this.tyresData.age;
              }

              if (
                typeof this.VehicleInspections.brakes != "undefined" &&
                this.VehicleInspections.brakes != ""
              ) {
                this.brakesData = JSON.parse(this.VehicleInspections.brakes);
                if (
                  typeof this.brakesData.brakes != "undefined" &&
                  this.brakesData.brakes != ""
                ) {
                  this.NewInspection.brakes = this.brakesData.brakes;
                }
                if (
                  typeof this.brakesData.vehicle != "undefined" &&
                  this.brakesData.vehicle != ""
                ) {
                  this.NewInspection.vehicle = this.brakesData.vehicle;
                }
                if (
                  typeof this.brakesData.roadBrake != "undefined" &&
                  this.brakesData.roadBrake != ""
                ) {
                  this.NewInspection.roadBrake = this.brakesData.roadBrake;
                }
                if (
                  typeof this.brakesData.brakeTemperature != "undefined" &&
                  this.brakesData.brakeTemperature != ""
                ) {
                  this.NewInspection.brakeTemperature =
                    this.brakesData.brakeTemperature;
                }

                var brakesData = 1;
                this.brakesList = [];
                this.brakesData.brakes.forEach((element) => {
                  this.brakesList.push(brakesData);
                  brakesData++;
                });
              }
              this.NewInspection.current_mileage =
                this.VehicleInspections.current_mileage;
              this.NewInspection.notes = this.VehicleInspections.notes;

              if (this.VehicleInspections.rectifications) {
                this.RectificationsData = JSON.parse(
                  this.VehicleInspections.rectifications
                );
                this.RectificationsData.forEach((element, index) => {
                  if (typeof element.fleet_document_id == "undefined") {
                    this.RectificationsData[index]["fleet_document_id"] = "";
                  }
                  if (typeof element.cost == "undefined") {
                    this.RectificationsData[index]["cost"] = "";
                  }
                  if (typeof element.file_name == "undefined") {
                    this.RectificationsData[index]["file_name"] = "";
                  }
                  if (typeof element.inspection_id == "undefined") {
                    this.RectificationsData[index]["inspection_id"] = "";
                  }
                });
                this.VehicleInspections.rectifications =
                  this.RectificationsData;
              }

              var indexData = 0;
              Response.data.FleetInspections.forEach((element, indexFirst) => {
                element.inspections.forEach((elementData, index) => {
                  this.NewInspection.inspection_submit_id.push(elementData.id);
                  this.NewInspection.marking_code[indexData] =
                    elementData.submitted_value > 0
                      ? elementData.submitted_value
                      : 1;
                  this.FleetInspectionsList[indexFirst]["inspections"][index][
                    "indexdata"
                  ] = indexData;

                  indexData++;
                });
              });
            } else {
              var indexData = 0;
              Response.data.FleetInspections.forEach((element, indexFirst) => {
                element.inspections.forEach((elementData, index) => {
                  this.NewInspection.inspection_submit_id.push(elementData.id);
                  this.NewInspection.marking_code.push(1);
                  this.FleetInspectionsList[indexFirst]["inspections"][index][
                    "indexdata"
                  ] = indexData;
                  indexData++;
                });
              });
            }
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });

        for (let i = 0; i <= 12; i++) {
          this.NewInspection.mm.push(null);
          this.NewInspection.psi.push(null);
          this.NewInspection.age.push(null);
        }
      },
      CreateVehicleInspection(type) {
        this.submitted = true;
        this.$v.$touch();
        if (type == "submit") {
          this.$swal({
            title: "Are you sure You want to submit this inspection?",
            text: "",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, submit it!",
            reverseButtons: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.$swal.close();
              this.saveInspectionData(type);
            }
          });
        } else {
          this.saveInspectionData(type);
        }
      },
      saveInspectionData(type) {
        this.Saving = true;
        this.NewInspection.save_type = type;
        this.NewInspection.form_type = this.FormType;
        this.NewInspection.inspection_id = this.InspectionId;
        this.NewInspection.unique_id = this.UniqueId;
        this.NewInspection.rectifications = this.RectificationsData;
        this.NewInspection.unique_url =
          window.location.origin + "/create-vehicle-inspection/";
        Axios.post(Endpoints.VehicleInspections.Create, {
          ...this.NewInspection,
        }).then((Response) => {
          this.Saving = false;
          if (Response.data.success) {
            var message = "Inspection Added Successfully";
            if (this.FormType == "Edit") {
              message = "Inspection Updated Successfully";
            }
            this.$swal.fire(message, "", "success").then(() => {
              if (type == "submit") {
                this.$router.go();
              }
            });
          } else {
            this.$swal.fire({
              title: "Oops!",
              text: Response.data.message,
              icon: "error",
              confirmButtonText: "Close",
            });
          }
        });
      },
      DownloadDocument(file) {
        window.open(this.ImageEndpoint + file, "_blank");
      },
      handleFileUpload(counter) {
        var file_data = $("#ins_doc_" + counter).prop("files")[0];
        let formData = new FormData();
        formData.append("token", localStorage.getItem("token"));
        formData.append("storage_type", "CFVI");
        formData.append("file", file_data);
        Axios.post(Endpoints.File.Upload, formData).then((Response) => {
          this.PopupLoader = false;
          if (Response.data.success == true) {
            this.RectificationsData[counter].file_name = Response.data.file;
            /* this.$swal
            .fire("File Uploaded Successfully", "", "success")
            .then(() => {}); */
          } else {
            this.$swal
              .fire("Error in File Uploading", "", "error")
              .then(() => {});
          }
        });
      },
      setRectificationsData(insID, insName, type) {
        if (type == 2 || type == 5) {
          this.RectificationsData.push({
            name: insName,
            value: "",
            type: type,
            cost: "",
            inspection_id: insID,
            file_name: "",
            fleet_document_id: "",
          });
        } else {
          this.RectificationsData.forEach((el, index) => {
            if (el.name === insName) this.RectificationsData.splice(index, 1);
          });
        }
      },
    },
  };
</script>
<style scoped>
  .table td {
    padding-left: 0.75rem !important;
  }
  .InspectionsListDiv {
    padding-right: 17px;
    margin-bottom: 20px;
  }
  .InspectionsListDivSubmit .InspectionsListDiv {
    height: 300px;
    overflow-y: scroll;
    padding-right: 17px;
    margin-bottom: 20px;
  }
  .custom-scrollbar thead th {
    top: -1px;
  }
  .innserSection {
    display: block;
    height: 450px;
  }
  .mm_psi_box {
    display: inline-block;
    width: 120px;
    text-align: center;
    margin-right: 5px;
  }
  .mm_box {
    display: inline-block;
    width: 60px;
  }
  .psi_box {
    display: inline-block;
    width: 60px;
  }
  .mm_box span,
  .psi_box span {
    display: block;
    width: 60px;
    padding: 3px 0;
    margin: 0;
    height: 42px;
  }
  .mm_box label,
  .psi_box label {
    display: block;
    line-height: 13px;
  }
  .markings_box {
    display: inline-block;
    width: 100px;
    padding: 3px 0;
    height: 42px;
  }

  .firstBox2 .markings_box {
    width: 160px !important;
  }

  .firstBox .markings_box,
  .firstBox2 .markings_box {
    width: 150px;
    height: 42px;
  }
  .firstBox .mm_psi_box {
    width: 210px;
  }
  .firstBox .mm_box,
  .firstBox .psi_box,
  .firstBox2 .mm_box,
  .firstBox2 .psi_box,
  .firstBox .psi_box span,
  .firstBox .mm_box span {
    width: 100px;
    height: 42px;
  }
  .firstBox {
    transform: rotate(270deg);
    width: 200px;
    position: absolute;
    right: -76px;
    top: 96px;
  }
  .firstBox2 {
    transform: rotate(270deg);
    width: 200px;
    position: absolute;
    right: -78px;
    top: 138px;
  }
  .TyresSection {
    position: relative;
  }
  .heightAuto {
    height: auto !important;
  }
  .inspections-list {
    padding: 5px 0;
    border-bottom: 1px solid #eee;
  }
  .TyresSection input {
    text-align: center;
  }
  .brakesDiv {
    border-top: 1px solid #ddd;
    margin-top: 10px !important;
    padding-top: 20px;
  }

  .submit-inspection-container {
    max-width: 75%;
    margin: 0px auto;
  }
  .redCard,
  .redCard:hover {
    box-shadow: 0 0 10px #f44336;
  }
  .price-sign {
    position: absolute;
    top: 0px;
    background: #e1e1e1;
    padding: 7px;
    font-size: 16px;
    border-radius: 5px 0 0 5px;
  }
  .padding-left {
    padding-left: 30px;
  }
  @media (max-width: 760px) {
    .submit-inspection-container {
      max-width: 100%;
    }
    .inspections-list .col-sm-6 {
      width: 87%;
      padding-bottom: 7px;
    }
    .inspections-list .col-sm-2 {
      width: 13%;
    }
    .inspections-list .col-sm-4 {
      width: 100%;
      padding-bottom: 12px;
    }
    .faq-body2 {
      height: 640px;
    }
    .faq-body3 {
      height: 395px;
    }
    .TyresSection .firstBox {
      top: 160px;
    }
    .brake-age-mobile-view .mm_psi_box {
      width: 53px;
    }
    .brake-age-mobile-view .markings_box {
      width: 57px;
    }
    .brake-age-mobile-view .m-r-30 {
      margin-right: 40px;
    }
    .brake-age-mobile-view .firstBox2 {
      top: 193px;
    }
    .brake-age-mobile-view .p-b-50 {
      padding-bottom: 0px !important;
    }
    .mobile-heading h1 {
      font-size: 20px;
    }
    .logomain.logo {
      width: 178px;
    }
    .create-inspection .col-sm-6,
    .col-sm-12,
    .col-sm-4,
    .no-padding,
    .col-sm-3 {
      padding-left: 0px;
      padding-right: 0px;
    }
    .create-inspection .InspectionsListDiv {
      padding-right: 0px;
    }
    .create-inspection .navbar {
      padding: 10px;
    }
  }
  @media (min-width: 1280px) and (max-width: 1680px) {
    .mm_psi_box {
      width: 103px;
    }
    .mm_box span,
    .psi_box span {
      width: 50px;
    }
    .mm_box,
    .psi_box {
      width: 50px;
    }
    .markings_box {
      width: 75px;
    }
    .firstBox2 {
      top: 151px;
    }
  }
</style>
